import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { WidgetSubtitle } from "app/components/React/Widgets/WidgetsSubtitle";
import { WeShare } from "app/components/weshare/weshare";
import { i18nFilter } from "app/filters/i18nFilter";
import { MetricTypeToggle } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/MetricTypeToggle";
import { Title } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/Title";
import { PngDownload } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/Components/PngDownload";
import { DEFAULT_WEBSITES_DELIMITER } from "app/services/sitesService/consts";

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 24px 18px 24px;
    align-items: center;
`;

const UtilitiesContainer = styled.div`
    display: flex;
    gap: 8px;
    @media print {
        display: none;
    }
`;

export const ChartHeader = ({ chartRef }) => {
    const { params = {} } = useCurrentStateAndParams();
    const { keys = "" } = params;
    const mainSite = keys.split(DEFAULT_WEBSITES_DELIMITER)[0];
    return (
        <Container>
            <div>
                <Title />
                <WidgetSubtitle />
            </div>
            <UtilitiesContainer>
                <MetricTypeToggle />
                <PngDownload
                    metricName={i18nFilter()("analysis.audience.overlap.overtime.title")}
                    chartRef={chartRef}
                    offset={{ x: 20, y: 50 }}
                />
                <WeShare
                    chartRef={chartRef.current}
                    title={i18nFilter()("analysis.audience.overlap.overtime.title")}
                    description={i18nFilter()("analysis.audience.overlap.overtime.title")}
                    redirectUrl={`https://www.similarweb.com/website/${mainSite}/#overview`}
                />
            </UtilitiesContainer>
        </Container>
    );
};
